<template>
    <table class="table table-hover" v-if="records.length > 0">
        <colgroup>
            <col width="40%">
            <col width="auto">
            <col width="150">
            <col width="40">
        </colgroup>
        <thead>
            <tr>
                <th  v-for="(fieldName, index) in recordFieldsToDisplay" :key="index">
                    {{ translate('label.location.' + fieldName) }}
                </th>
                <th></th>
            </tr>
        </thead>
     
        <collapsible-table-row v-for="record in paginatedRecords" :key="record.id"
                               :record="record"
                               :record-fields-to-display="recordFieldsToDisplay"
                               :record-detail-fields-to-display="recordDetailFieldsToDisplay"
                               :show-private-type="showPrivateType"
                               :show-royal-type="showRoyalType"
                               :show-place-of-writing="showPlaceOfWriting"
                               :show-place-of-goods="showPlaceOfGoods"
                               :show-mentioned-place="showMentionedPlace"
                               :show-only-exhibited="showOnlyExhibited">
        </collapsible-table-row>

    <infinite-loading spinner="spiral" @infinite="infiniteHandler" :identifier="infiniteLoadingId">
    <div slot="no-results"></div>
    </infinite-loading>

   </table>
    

   <div v-else class="text-center mt-3">
        {{ translate('label.location.no_results') }}
    </div>
</template>

<script>
    import InfiniteLoading from 'vue-infinite-loading';
    
    export default {
        components: {
            InfiniteLoading
        },

        data() {
            return {
                numberOfDisplayedLocations: 50,
                infiniteLoadingId: + new Date() + this.numberOfDisplayedLocations
            }
        },

        props: {
            records: { type: Array, required: true },
            recordFieldsToDisplay: { type: Array, required: true },
            recordDetailFieldsToDisplay: { type: Array, required: false },
            showPrivateType: { type: Boolean, required: false, default: true },
            showRoyalType: { type: Boolean, required: false, default: true },
            showPlaceOfWriting: { type: Boolean, required: false, default: true },
            showPlaceOfGoods: { type: Boolean, required: false, default: true },
            showMentionedPlace: { type: Boolean, required: false, default: true },
            showOnlyExhibited: { type: Boolean, required: false, default: false }
        },
        watch: {
            records: function (newRecords) {
                EventDispatcher.fire('recordsCountChanged', newRecords.length);
                this.infiniteLoadingId = + new Date() + this.numberOfDisplayedLocations;
                this.numberOfDisplayedLocations = 50;
            }
        },

        computed: {
            paginatedRecords() {
                return this.records.slice(0, this.numberOfDisplayedLocations);
            }
        },

        methods: {
            infiniteHandler(state) {
                if(this.numberOfDisplayedLocations < this.records.length) {
                    this.numberOfDisplayedLocations += 50;
                    this.infiniteLoadingId = + new Date() + this.numberOfDisplayedLocations;
                } else {
                    state.complete();
                }
            }
        }
    }
</script>